export default "__VITE_ASSET__BWB7XA_A__"